import { render, staticRenderFns } from "./EditCompensation.vue?vue&type=template&id=7ebf6928"
import script from "./EditCompensation.vue?vue&type=script&lang=js"
export * from "./EditCompensation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports